module.exports = __webpack_public_path__ + "img/size_2_1.85b30271.png";